import { RouteInterface } from '@/src/common/enums/routes'

export const PointsToCashForMortgageRoutes = {
  PointsToCashForMortgage: {
    route: '/main/points-to-cash-for-mortgage',
    name: 'Turn Points into Cash for Your Mortgage',
    availableForDeepLinking: true,
  },
  MortgageAddressSelector: {
    route: '/main/points-to-cash-for-mortgage/mortgage-address-selector',
    name: 'Mortgage Address Selector',
    availableForDeepLinking: false,
  },
  MortgageAddress: {
    route: '/main/points-to-cash-for-mortgage/mortgage-address',
    name: 'Mortgage Address',
    availableForDeepLinking: false,
  },
  CashForMortgageDestinationAccount: {
    route: '/main/points-to-cash-for-mortgage/destination-account',
    name: 'Cash for Mortgage Destination Account Selector',
    availableForDeepLinking: false,
  },
  CashForMortgageRedemptionConfirmation: {
    route: '/main/points-to-cash-for-mortgage/redemption-confirmation',
    name: 'Cash for Mortgage Redemption Confirmation',
    availableForDeepLinking: false,
  },
  CashForMortgageSuccessConfirmation: {
    route: '/main/points-to-cash-for-mortgage/success-confirmation',
    name: 'Cash for Mortgage Success Confirmation',
    availableForDeepLinking: false,
  },
} as const satisfies Record<string, RouteInterface>
